import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Page from 'components/layout/Page/Page';
import DashboardToolbar from './components/DashboardToolbar';
import RemindersWidget from './components/widgets/RemindersWidget/RemindersWidget';
import LogsSummaryWidget from './components/widgets/LogsSummaryWidget/LogsSummaryWidget';
import WorkersWidget from './components/widgets/WorkersWidget/WorkersWidget';
import TodosWidget from './components/widgets/TodosWidget/TodosWidget';
import {
  fetchSummary,
  selectStatPeriod,
  selectSummary,
  selectSummaryStatus,
  selectSummaryError,
} from 'store/slices/dashboardSlice';

function Dashboard() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const statPeriod = useSelector(selectStatPeriod);
  const summary = useSelector(selectSummary);
  const summaryStatus = useSelector(selectSummaryStatus);
  const summaryError = useSelector(selectSummaryError);

  useEffect(() => {
    dispatch(fetchSummary(statPeriod));
  }, [dispatch, statPeriod]);

  const isLoading = summaryStatus === 'loading';
  const initialLoading = isLoading && !summary;
  const error = summaryStatus === 'failed' ? summaryError : null;

  const handleRetry = useCallback(() => {
    dispatch(fetchSummary(statPeriod));
  }, [dispatch, statPeriod]);

  return (
    <Page title="Dashboard">
      <DashboardToolbar user={user} />

      <div className="mt-6 space-y-6">
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          <LogsSummaryWidget
            data={summary?.logs}
            loading={initialLoading}
            error={error}
            onRetry={handleRetry}
          />
          <RemindersWidget
            data={summary?.reminders?.byStatus}
            typeData={summary?.reminders?.byType}
            frequencyData={summary?.reminders?.byFrequency}
            loading={initialLoading}
            error={error}
            onRetry={handleRetry}
          />
        </div>

        <div className="flex flex-col gap-4 lg:flex-row">
          <div className="w-full lg:w-1/4">
            <WorkersWidget
              data={summary?.workers?.byType}
              loading={initialLoading}
              error={error}
              onRetry={handleRetry}
            />
          </div>
          <div className="w-full lg:w-1/2">
            <TodosWidget
              statusData={summary?.todos?.byStatus}
              priorityData={summary?.todos?.byPriority}
              assignmentData={summary?.todos?.assignment}
              loading={initialLoading}
              error={error}
              onRetry={handleRetry}
            />
          </div>
        </div>
      </div>
    </Page>
  );
}

export default Dashboard;
